export default __webpack_public_path__ + "static/media/gallery_00.d0659477.jpg";